module.exports = __webpack_public_path__ + "static/media/logo_circle_white.bbbd9362.svg";